import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import axios from 'axios'

function AddBrand() {

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [response, setResponse] = useState("");
    const [failedResponse, setFailedResponse] = useState("");
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const onSubmit = (requestedData) => { 
    console.log(requestedData);
      setResponse("");
      setFailedResponse("");
    axios.post(baseUrl+"/api/v1/vehicle/brand/add", requestedData).then((res) =>{
        console.log("Response for fetchdata",res.data.msg);
        console.log("Response for fetchdata",res.data.status);
        if(res.data.status == 'OK'){
            setResponse(res.data.msg);
        }else{
            setFailedResponse(res.data.msg)
        }
        
        console.log(baseUrl,"BASE URL")
       }).catch(err =>{
         console.log("ERROR    ",err);
         console.log("BASE URL    ",baseUrl);
       });
  }
  return (
    
    
    <div className="col-lg-8 col-md-8 mx-auto" style={{marginTop:"7%"}}>
                  <div className="card-body p-4 p-lg-5 text-black" style={{backgroundColor:"#fff"}}>
                  <p className="text-center">ADD BRAND</p>
                  {response.length > 0 ? 
                  <div class="alert alert-success" role="alert">
                      {response}
                   </div>:""
                   }
                    {failedResponse.length > 0 ? 
                  <div class="alert alert-danger" role="alert">
                      {failedResponse}
                   </div>:""
                   }

                    <form noValidate onSubmit={handleSubmit(onSubmit)}>
                      <div className="form-outline mb-2 ">
                      <label className="form-label-dk" htmlFor="form2Example17">Brand Name</label>
                        <input type="text" name="brandName" className="form-control form-control-md" {...register("brandName", { required: true })}/>
                        {errors.brandName && <span className="form-error-dk">This field is required</span>}
                      </div>
                      
                      <div className="form-outline mb-2 ">
                      <label className="form-label-dk" htmlFor="form2Example17">Brand Label</label>
                        <input type="text" name="brandLabel" className="form-control form-control-md" {...register("brandLabel", { required: true })}/>
                        {errors.brandLabel && <span className="form-error-dk">This field is required</span>}
                      </div>
                      
                      <div className="form-outline mb-2 ">
                      <label className="form-label-dk" htmlFor="form2Example17">Short Description</label>
                        <textarea name="shortDescription" className="form-control form-control-md" {...register("shortDescription", { required: true })}/>
                        {errors.shortDescription && <span className="form-error-dk">This field is required</span>}
                      </div>
                      
    
                      <div className="col-md-12 col-lg-12 d-flex ">
                      <div className="pt-1 mb-4">
                        <button className="btn btn-dark btn-lg btn-block" type="submit">Add</button>
                      </div>
                     
                      </div>
                     
                    </form>
    
                  </div>
                </div>
    
  )
}

export default AddBrand
